import angular from 'angular';
import moment from 'moment';

function UtcFilter() {
  return function (date) {
    const isMoment = moment.isMoment(date);

    if (isMoment) {
      date = date.toDate();
    }

    if (date) {
      if (angular.isNumber(date) || typeof date === 'string') {
        date = new Date(date);
      }

      const newDate = new Date(
        date.getUTCFullYear(),
        date.getUTCMonth(),
        date.getUTCDate(),
        date.getUTCHours(),
        date.getUTCMinutes(),
        date.getUTCSeconds());

      return isMoment ?
        moment(newDate) :
        newDate;
    }

    return null;
  };
}

UtcFilter.$inject = [];

export default UtcFilter;



// WEBPACK FOOTER //
// ./src/filters/utcFilter.js